module.exports = __webpack_public_path__ + "img/chiva-cristal-main-bg1.be20dbdc.jpg";